import { PublicProfileService } from '@features/public-profile/data-access/services/public-profile.service';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PublicProfileActions, PublicProfileResetActions } from '../actions/public-profile.actions';
import { catchError, map, mergeMap, of, switchMap, throwError } from 'rxjs';
import { HttpError, HttpResponse } from '@shared/utils/models/http.model';
import { LogActionResponse, UserPublicProfile } from '@features/public-profile/utils/models/public-profile.model';

@Injectable()
export class PublicProfileEffects {
  private readonly publicProfileService = inject(PublicProfileService);
  private readonly actions$ = inject(Actions);

  getPublicProfile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicProfileActions.getPublicProfile, PublicProfileResetActions.cancelPublicProfileActions),
      switchMap((action) =>
        action.type === PublicProfileResetActions.cancelPublicProfileActions.type
          ? of(PublicProfileResetActions.cancelPublicProfileActionsSuccess())
          : this.publicProfileService.getPublicProfile(action.slug).pipe(
              switchMap((response: HttpResponse<[UserPublicProfile] | string>) => {
                if (response.code === 'DISABLED_PROFILE') {
                  return throwError(() => ({ message: response.message as string, code: response.code }));
                }
                return of(PublicProfileActions.getPublicProfileSuccess({ profile: response.message[0] as UserPublicProfile }));
              }),
              catchError((error: HttpError) => of(PublicProfileActions.getPublicProfileFailure({ error })))
            )
      )
    );
  });

  logAction$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicProfileActions.logAction),
      mergeMap((action) =>
        this.publicProfileService.logAction({ user_id: action.userId, action_id: action.actionId }).pipe(
          map((response: HttpResponse<LogActionResponse>) =>
            PublicProfileActions.logActionSuccess({ data: response.message })
          ),
          catchError((error: HttpError) => of(PublicProfileActions.logActionFailure({ error })))
        )
      )
    );
  });
}
